import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Menu from '@/components/Menu'
import Dashboard from '@/components/Dashboard/Dashboard'
const Vacantes  	= () => import('@/components/Vacantes/Vacantes');
const Chat    = () => import('@/components/Chat/Chat');
const Postulaciones    = () => import('@/components/Vacantes/Postulaciones');
const Empresas  	= () => import('@/components/Empresas/Empresas');
const TotalPostulaciones = () => import('@/components/Empresas/TotalPostulaciones');
const Empresa    = () => import('@/components/Empresas/Empresa');
const Usuarios = () => import('@/components/Usuarios');
const Perfiles = () => import('@/components/Perfiles');

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/', name: 'Login', component: Login
    },
    {
      path: '/menu', name: 'Menu', component: Menu, children:[
      	{path:'dashboard',name:'Dashboard',component:Dashboard},
      	{path:'vacantes',name:'Vacantes',component:Vacantes},
        {path:'chat',name:'Chat',component:Chat},
        {path:'postulaciones/:idcliente/:idvacante',name:'Postulaciones',component:Postulaciones},
      	{path:'empresas',name:'Empresas',component:Empresas},
        {path:'empresas/:idcliente',name:'Empresa',component:Empresa},
        {path:'usuarios',name:'Usuarios',component:Usuarios},
        {path:'perfiles',name:'Perfiles',component:Perfiles},
        {path:'totalpostulaciones/:idcliente',name:'TotalPostulaciones',component:TotalPostulaciones}
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js